import { capitalize } from 'lodash';

const objFromRole = (role) => ({
  name: capitalize(role),
  value: role,
});

export const TEAM_ROLES = ['viewer', 'editor', 'admin'].map(objFromRole);

export const FARM_ROLES = ['viewer', 'editor'].map(objFromRole);

export const VIEWER_ROLE = [objFromRole('viewer')];
